module.exports = __webpack_public_path__ + "img/ethereum.fb666fbb.svg";